import React from 'react'

function ChevronUpIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.675 10a.666.666 0 0 1-.473-.194L8.007 7.594 5.805 9.806a.667.667 0 0 1-1.087-.732.668.668 0 0 1 .146-.217L7.533 6.19a.667.667 0 0 1 .934 0l2.669 2.673a.668.668 0 0 1 0 .949.667.667 0 0 1-.46.187Z"
      />
    </svg>
  )
}

export default ChevronUpIcon
